import type * as React from "react";
import classNames from "classnames";
import NullableImage from "../../../common/components/NullableImage";
import CenterContents from "../../../common/components/CenterContents";
import { type ImgData } from "../../../utils/models";
import { usePrevious } from "../../../common/hooks/usePrevious";

export interface NavImageProps {
  className?: string;
  imageData: ImgData;
}

const FADE_IN = "scha__fade-in-out__element scha__fade-in-out__fade-in";
const FADE_OUT = "scha__fade-in-out__element scha__fade-in-out__fade-out";

const NavImage: React.FC<NavImageProps> = ({ className, imageData }) => {
  const prevImageData = usePrevious(imageData);
  return (
    <CenterContents className={classNames("scha__sub-nav__img", className)}>
      {[
        imageData && (
          <NullableImage
            className={FADE_IN}
            key={`old${imageData.url}${imageData.altText}${imageData.id}`}
            data={imageData}
          />
        ),
        prevImageData && prevImageData !== imageData && (
          <NullableImage
            className={FADE_OUT}
            key={`old${prevImageData.url}${prevImageData.altText}${prevImageData.id}`}
            data={prevImageData}
          />
        ),
      ]}
    </CenterContents>
  );
};
export default NavImage;
